<template>
  <div class="vue-map-container">
    <div ref="mapContainer" class="map-container"></div>
  </div>
</template>

<script>
// Typescript will not be used as it causes issue with the mapbox container ref type
import 'mapbox-gl/dist/mapbox-gl.css'
import { Component, Vue, Prop } from 'vue-property-decorator'
import mapboxgl from 'mapbox-gl'
import config from '@/config'
mapboxgl.accessToken = config.mapbox.accessToken

@Component
export default class LocationMapMapbox extends Vue {
  @Prop({ required: true }) location
  @Prop({ default: [] }) locations
  @Prop refLocation
  @Prop isRefLocationVisible

  mounted () {
    let map = new mapboxgl.Map({
      container: this.$refs.mapContainer,
      style: 'mapbox://styles/mapbox/streets-v11', // Replace with your preferred map style
      center: [this.location.lng, this.location.lat],
      zoom: 11
    })
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')
    this.map = map
    setTimeout(() => {
      this.map.resize()
      this.map.setLayoutProperty('country-label', 'text-field', ['get', 'name_es'])
    }, 100)

    const locationMarker = new mapboxgl.Marker({
      color: 'green'
    }).setLngLat([this.location.lng, this.location.lat])
    locationMarker.addTo(this.map)
    locationMarker.setPopup(new mapboxgl.Popup({ closeButton: false }).setHTML(this.createMakerLabelHTML(this.location)))

    const locationsMarkers = this.locations.map((loc) => {
      const marker = new mapboxgl.Marker({
        color: 'red'
      })
      marker.setLngLat([loc.lng, loc.lat])
      return marker
    })

    locationsMarkers.map((marker, index) => {
      marker.addTo(this.map)
      marker.setPopup(new mapboxgl.Popup({ closeButton: false }).setHTML(this.createMakerLabelHTML(this.locations[index], index)))
    })
  }

  unmounted () {
    this.map.remove()
    this.map = null
  }

  createMakerLabelHTML (location, index = null) {
    return index === null
      ? `<p class="markerLabel">${location.label}</p>`
      : `<p class="markerLabel">${location.label ?? 'Ubicación ' + index + 1}</p><p class="markerLabel">${this.getLocationDistanceText(this.location, location)}</p>`
  }

  getLocationDistanceText (locationA, locationB) {
    return `Distancia: ${locationA.haversineDistance(locationB).toFixed(2)} KM`
  }
}

</script>

<style>
.vue-map-container {
  height: 100%;
  width: auto;

  .map-container {
      position: relative;
      width: 100%;
      height: 100%;
  }
}

.mapboxgl-popup-content {
  padding: 5px;
}

.markerLabel {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
